import styled from "styled-components";

/**
 * Wrapper do Dropdown de Seleção de Hóspedes
 * Configura o layout principal e o comportamento visual do dropdown.
 */
export const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing(3)};
  top: ${({ theme }) => theme.spacing(9)};
  box-shadow: ${({ theme }) => theme.shadows.light.medium};
  position: absolute;
  right: 0;
  z-index: 10;
  min-width: ${({ theme }) => theme.spacing(60)};
  max-width: ${({ theme }) => theme.spacing(70)};
  transition:
    opacity 0.2s ease-in-out,
    transform 0.2s ease-in-out;

  &.visible {
    opacity: 1;
    transform: translateY(0);
  }

  &.hidden {
    opacity: 0;
    transform: translateY(-10%);
    pointer-events: none;
  }
`;

export const DropdownWrapperMobile = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: ${({ theme }) => theme.spacing(1)} 0;
  /* top: ${({ theme }) => theme.spacing(9)}; */
  z-index: 10;
  width: 90%;
`;
